// import external dependencies
// import 'jquery';
// per far funzionare headroom bisogna modificare webpack.config.js
// aggiungendo all'interno dei plugin headroom:
//
// new webpack.ProvidePlugin({
//       Headroom: 'headroom.js'
//     }),
// import 'headroom.js/dist/$.headroom';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import blog from './routes/blog';
import category from './routes/category';
import tag from './routes/tag';
import archive from './routes/archive';

import templatePortfolio from './routes/templatePortfolio';
import singlePortfolio from './routes/singlePortfolio';
import templateEventiPassati from './routes/templateEventiPassati';
import uniscitiAlTeam from './routes/uniscitiAlTeam';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  blog, // pagina blog (index articoli)
  category, // pagina Categoria
  tag, // pagina Tag
  archive, // pagina archivio
  templatePortfolio, // archivioportfolio
  templateEventiPassati, // archivio eventi passati
  singlePortfolio, // portfolio pagina singola
  uniscitiAlTeam, // pagina lavora con noi
});

// Load Events
$(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js